import { FaRegEyeSlash } from 'react-icons/fa';
import styled, { css } from 'styled-components';

const EyeSlashIcon = styled(FaRegEyeSlash)(
  ({ theme, size = 'inherit', color = 'inherit' }) => css`
    font-size: ${size};
    color: ${color};
  `
);

export { EyeSlashIcon };
